import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import { RouteLoadingFallback } from '../components/global/RouteLoadingFallback/RouteLoadingFallback.tsx';
import { Account } from '../views/account/Account.tsx';
import { Login } from '../views/auth/Login.tsx';
import { CodeVerification } from '../views/auth/ResetPassword/CodeVerification.tsx';
import { Email } from '../views/auth/ResetPassword/Email.tsx';
import { Password } from '../views/auth/ResetPassword/Password.tsx';
import { Success } from '../views/auth/ResetPassword/Success.tsx';
import { SignUp } from '../views/auth/SignUp.tsx';
import { VerifyEmail } from '../views/auth/VerifyEmail/VerifyEmail.tsx';
import { Dashboard } from '../views/dashboard/Dashboard.tsx';
import { EventEdit } from '../views/eventEdit/EventEdit.tsx';
import { IncompleteEventEdit } from '../views/incompleteEventEdit/IncompleteEventEdit.tsx';
import { LogInAs } from '../views/LogInAs/LogInAs.tsx';
import { EventAbout } from '../views/onboarding/EventAbout.tsx';
import { EventCoverImage } from '../views/onboarding/EventCoverImage.tsx';
import { EventLinks } from '../views/onboarding/EventLinks.tsx';
import { EventPreview } from '../views/onboarding/EventPreview.tsx';
import { EventWhereAndWhen } from '../views/onboarding/EventWhereAndWhen.tsx';
import { CommunityNotes } from '../views/onboarding/lib/CommunityNotes.tsx';
import { ThankYou } from '../views/onboarding/ThankYou.tsx';
import { UserAndPromoter } from '../views/onboarding/UserAndPromoter.tsx';
import { Root } from '../views/Root.tsx';
import { SocialLogin } from '../views/socialLogin/SocialLogin.tsx';
import { WrongRole } from '../views/wrongRole/WrongRole.tsx';
import { dashboardLoader } from './dashboardLoader.tsx';
import { protectedLoader } from './protectedLoader.tsx';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Root />} hydrateFallbackElement={<RouteLoadingFallback />} path="/">
      <Route index element={<Navigate replace to="dashboard" />} />
      <Route path="auth">
        <Route element={<SignUp />} path="signup" />
        <Route element={<Login />} path="login" />
        <Route element={<VerifyEmail />} path="verification-email-sent/:userId" />
        <Route path="reset-password">
          <Route index element={<Navigate replace to="email" />} />
          <Route element={<Email />} path="enter-email" />
          <Route element={<CodeVerification />} path="code-verification" />
          <Route element={<Password />} path="password" />
          <Route element={<Success />} path="success" />
        </Route>
      </Route>
      <Route loader={protectedLoader}>
        <Route element={<Account />} path="account" />
        <Route element={<CommunityNotes />} path="community-notes" />
        <Route path="onboarding">
          <Route index element={<Navigate replace to="tell-me-more" />} />
          <Route element={<UserAndPromoter />} path="tell-me-more" />
          <Route element={<EventAbout />} path="about" />
          <Route element={<EventWhereAndWhen />} path="where-when" />
          <Route element={<EventCoverImage />} path="art-work" />
          <Route element={<EventLinks />} path="links" />
          <Route element={<EventPreview />} path="preview" />
          <Route element={<ThankYou />} path="thank-you" />
        </Route>
        <Route path="incomplete-event">
          <Route path=":id">
            <Route element={<IncompleteEventEdit />} path="edit" />
            <Route element={<IncompleteEventEdit isCreate />} path="create" />
          </Route>
        </Route>
        <Route path="event">
          <Route path=":id">
            <Route element={<EventEdit />} path="edit" />
          </Route>
        </Route>
        <Route loader={dashboardLoader} path="dashboard">
          <Route index element={<Navigate replace to="published" />} />
          <Route element={<Dashboard />} path=":status" />
        </Route>
      </Route>
      <Route element={<WrongRole />} path="wrong-role" />
      <Route element={<LogInAs />} path="log-in-as" />
      <Route element={<SocialLogin />} path="social-login" />
    </Route>,
  ),
);
